// extracted by mini-css-extract-plugin
export var heroImageWidth = "ifirma-module--heroImageWidth--6qzns";
export var heroCopyWidth = "ifirma-module--heroCopyWidth--72xpf";
export var ifirmaLogoWrapper = "ifirma-module--ifirmaLogoWrapper--2vToh";
export var main = "ifirma-module--main--f5GH8";
export var logo = "ifirma-module--logo--Drm9d";